<!-- Backdrop overlay -->
@if (!isMobile && !(collapsed$ | async)) {
  <div class="sidebar-backdrop" (click)="toggleSidebar()"></div>
}

<!-- Desktop Sidebar -->
@if (!isMobile) {
  <div class="sidebar" [ngClass]="{'collapsed': collapsed$ | async}">
    <div class="sidebar-content">
      <!-- Logo Section -->
      <div class="logo-section" (click)="navigate(navItems[0])" role="button">
        <img src="/assets/logo.png" alt="K" class="logo-icon">
      </div>
      <!-- AI Search Button -->
      @if (showAISearch) {
        <div class="nav-item nav-item-special"
          [ngClass]="{'nav-item-hidden': isAISearchHidden && isOnAdminPage}"
          (click)="isAISearchHidden ? null : openSearchModal()"
          role="button"
          [attr.aria-label]="'AI Search'">
          <i class="fa-solid fa-search nav-icon"></i>
          <span class="nav-label">AI Search</span>
        </div>
      }
      <!-- Navigation Items -->
      <nav class="nav-items">
        @for (item of navItems; track item) {
          @if (shouldShowNavItem(item)) {
            <div
              class="nav-item"
              [ngClass]="{
                'active': isNavItemActive(item),
                'disabled': isNavItemDisabled(item),
                'nav-item-hidden': isNavItemHiddenByOrgSettings(item) && isOnAdminPage
              }"
              (click)="isNavItemHiddenByOrgSettings(item) ? null : navigate(item)"
              role="button"
              [attr.aria-label]="item.label">
              <i class="fa-solid {{item.icon}} nav-icon"></i>
              <span class="nav-label">
                {{item.label}}
              </span>
            </div>
          }
        }

        <!-- Kartorium Super Admin Link (Kartorium staff only, distinct from client "super user" role) -->
        @if (showAdminLink) {
          <div
            class="nav-item nav-item-admin"
            [routerLink]="[adminNavItem.route]"
            routerLinkActive="active"
            role="button"
            [attr.aria-label]="adminNavItem.label">
            <i class="fa-solid {{adminNavItem.icon}} nav-icon"></i>
            <span class="nav-label">{{adminNavItem.label}}</span>
          </div>
        }
      </nav>
      <!-- Bottom Section -->
      <div class="sidebar-bottom">
        <!-- Toggle Button -->
        <div class="toggle-section" (click)="toggleSidebar()" role="button" [attr.aria-label]="(collapsed$ | async) ? 'Expand sidebar' : 'Collapse sidebar'">
          <i class="fa-solid nav-icon" [ngClass]="(collapsed$ | async) ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
        </div>
        <!-- Profile Section -->
        <div class="profile-section" role="button" aria-label="Open profile" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
          @if (currentUser$ | async; as user) {
            <img
              [src]="user.picture"
              alt="Profile"
              class="profile-picture">
          }
          <span class="profile-name text-truncate">
            Account
          </span>
        </div>
      </div>
    </div>
  </div>
}
